// Module
var code = "<customer-wrapup-form customer-reasons=\"$ctrl.state.customerWrapUpCodes\" on-model-change=\"$ctrl.onModelChange\">\n</customer-wrapup-form>\n";
// Exports
module.exports = code;